import AuthService from "./services";
import AuthHelpers from "@/utils/auth-helpers";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import axios from "@axios";
import router from "@/router/index";
import * as ep from "./endpoints";
import axios1 from "axios";
import Vue from "vue";

import { BACK_BASE_URL } from "@/base-url";

export default {
  namespaced: true,
  state: {
    loading: false,
    accessToken: AuthHelpers.getAccessToken(),
    passToken: AuthHelpers.getPassToken(),
    tokenType: AuthHelpers.getAccessTokenType(),
    modalPasswordMust: false,
    loadingPassword: false,
    transactions_need_review : 0,
    // emailPassword:{}
    idUser: null,
    token: null,
    user: null,
  },
  mutations: {
    setLoading(state, value) {
      state.loading = value;
    },
    setToken(state, value) {
      state.accessToken = value;
      axios.defaults.headers["Authorization"] = `Bearer ${value}`;
      AuthHelpers.setAccessToken(value);
    },
    setPassToken(state, value) {
      state.accessToken = value;
      AuthHelpers.setPassToken(value);
    },
    setTokenType(state, value) {
      state.tokenType = value;
      AuthHelpers.setAccessTokenType(value);
    },
    setTransactionsNeedReview(state, value) {
      state.transactions_need_review = value;
      AuthHelpers.setTransactionsNeedReview(value);
    },
    setModalPasswordMust(state, value) {
      state.modalPasswordMust = value;
    },
  },
  getters: {
    accessToken(state) {
      return state.accessToken;
    },
    passToken(state) {
      return state.passToken;
    },
    loading(state) {
      return state.loading;
    },
    modalPasswordMust(state) {
      return state.modalPasswordMust;
    },
    loadingPassword(state) {
      return state.loadingPassword;
    },
  },
  actions: {
    async login({ commit, state }, payload) {
      commit("setLoading", true);
      try {
        const data = await AuthService.login(payload);
        if (data.status === false) {
          throw data.message;
        }
        AuthHelpers.reset();
        if (data.data.user.password_must_change === 1) {
          commit("setModalPasswordMust", true);
          state.idUser = data.data.user.id;
          state.token = data.data.token;
          state.user = data.data.user;
        } else {
          commit("setModalPasswordMust", false);
          commit("setToken", data.data.token);
          commit("setTransactionsNeedReview", data.data.transactions_need_review);
          commit("User/setUser", data.data.user, { root: true });
          router.push({ name: "ngo-profile" });
        }
      } catch (err) {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "خطأ في البيانات",
            icon: "AlertCircleIcon",
            text: err,
            variant: "danger",
          },
        });
        commit("setLoading", false);
        return Promise.reject(false);
      } finally {
        commit("setLoading", false);
      }
    },
    async tempLogin({ commit }, payload) {
      commit("setLoading", true);
      try {
        const data = await AuthService.tempLogin(payload);
        if (data.status === false) {
          throw data.message;
        }
        AuthHelpers.reset();
        commit("setToken", data.data.token);
        commit("setTokenType", "t");
        commit("User/setUser", data.data.user, { root: true });
      } catch (err) {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "خطأ في البيانات",
            icon: "AlertCircleIcon",
            text: err,
            variant: "danger",
          },
        });
        commit("setLoading", false);
        return Promise.reject(false);
      } finally {
        commit("setLoading", false);
      }
    },
    async ministryLogin({ commit }, payload) {
      commit("setLoading", true);
      try {
        const data = await AuthService.ministryLogin(payload);
        if (data.status === false) {
          throw data.message;
        }
        AuthHelpers.reset();
        commit("setToken", data.data.token);
        commit("setPassToken", data.data.pass_token);
        commit("setTokenType", "m");
        commit("User/setUser", data.data.user, { root: true });
      } catch (err) {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "خطأ في البيانات",
            icon: "AlertCircleIcon",
            text: err,
            variant: "danger",
          },
        });
        commit("setLoading", false);
        return Promise.reject(false);
      } finally {
        commit("setLoading", false);
      }
    },
    getAccessToken() {
      const accessToken = AuthHelpers.getAccessToken();
      if (accessToken) {
        return accessToken;
      } else {
        return Promise.reject("unauthenticated");
      }
    },
    async logout({ commit }) {
      commit("setLoading", true);
      try {
        await AuthService.logout();
        AuthHelpers.reset();
      } catch (err) {
      } finally {
        commit("setLoading", false);
      }
    },
    async tempLogout({ commit }) {
      commit("setLoading", true);
      try {
        await AuthService.tempLogout();
        AuthHelpers.reset();
      } catch (err) {
      } finally {
        commit("setLoading", false);
      }
    },
    async ministryLogout({ commit }) {
      commit("setLoading", true);
      try {
        await AuthService.ministryLogout();
        AuthHelpers.reset();
      } catch (err) {
      } finally {
        commit("setLoading", false);
      }
    },
    async sliders() {
      try {
        return await AuthService.sliders();
      } catch (err) {}
    },

    setModalPassword(context, payload) {
      context.commit("setModalPasswordMust", payload);
    },

    async changePassword(context, payload) {
      context.state.loadingPassword = true;
      axios1.defaults.headers = {
        accept: "application/json",
        lang: "ar",
        "access-control-allow-origin": "*",
        "Access-Control-Allow-Headers": "*",
        Authorization: `Bearer ${context.state.token}`,
      };

      return await axios1
        .post(
          `${BACK_BASE_URL}/` + ep.CHANGE_PASSWORD(context.state.idUser),
          payload
        )
        .then((res) => {
          AuthHelpers.reset();
          context.state.loadingPassword = false;
          context.commit("setToken", context.state.token);
          context.commit("User/setUser", context.state.user, { root: true });
          context.commit("setModalPasswordMust", false);
          router.push({ name: "ngo-profile" });
          Vue.$toast({
            component: ToastificationContent,
            props: {
              icon: "AlertCircleIcon",
              title: res.data.message,
              variant: "success",
            },
          });
        })
        .catch((err) => {
          Vue.$toast({
            component: ToastificationContent,
            props: {
              icon: "AlertCircleIcon",
              title: err.response.data.message,
              variant: "danger",
            },
          });
        })
        .finally(() => {
          context.state.loadingPassword = false;
        });
    },
  },
};
